import { defineMessages } from 'react-intl';

/** The copy of the numbers on a channel card and on a totals card (design social-connectors a, b). */
export const channelNumbersMessages = defineMessages({
  followers: { id: 'app.sml.promote.channel.followers', defaultMessage: 'Followers' },
  subscribers: { id: 'app.sml.promote.channel.subscribers', defaultMessage: 'Subscribers' },
  firstWeek: { id: 'app.sml.promote.channel.firstWeek', defaultMessage: 'first week' },
  period: { id: 'app.sml.promote.channel.period', defaultMessage: 'Last {days} days' },
  updated: { id: 'app.sml.promote.channel.updated', defaultMessage: 'Updated {time}' },
  reading: { id: 'app.sml.promote.channel.state.reading', defaultMessage: 'Reading your numbers' },
  readingDetail: {
    id: 'app.sml.promote.channel.state.reading.detail',
    defaultMessage: 'The first read takes a few minutes. It covers your last 90 days.',
  },
  reconnectForNumbers: {
    id: 'app.sml.promote.channel.state.reconnectForNumbers',
    defaultMessage: 'Reconnect to see your numbers',
  },
  reconnectForNumbersDetail: {
    id: 'app.sml.promote.channel.state.reconnectForNumbers.detail',
    defaultMessage: 'Posting still works. A new sign-in lets MUSIC24 read your followers and posts.',
  },
  reconnect: { id: 'app.sml.promote.channel.reconnect', defaultMessage: 'Reconnect' },
  // The design copy says that the posts wait. They do not: a scheduled post falls back to the
  // manual post pack while the sign-in is gone.
  reconnectDetail: {
    id: 'app.sml.promote.channel.state.reconnect.detail',
    defaultMessage: '{platform} ended the sign-in. Posts to it come to you as a post pack until you reconnect.',
  },
});

/** YouTube counts subscribers. Every other platform counts followers. */
export function followersLabelMessage(platform: string) {
  return platform === 'youtube' ? channelNumbersMessages.subscribers : channelNumbersMessages.followers;
}
